import {
  getIdCidade, getIdCidadeEcrie, getIdCidadeEsipe, getTotem,
} from './apiFactory';
import apiService, { apiPost, apiPostSemPost, upload } from './apiService';

/* CARTA DE SERVIÇOS */

export const fetchServicos = async (IdSecretaria, PalavraChave) => apiPost(`/${await getIdCidade()}/cartadeservicos/listar`, { IdSecretaria, PalavraChave });

export const fetchServico = async (Valor) => apiPost(`/${await getIdCidade()}/cartadeservicos/carregar`, { Valor });

/* ENQUETES */

export const fetchEnquetesPergunta = () => apiService('/enquete/pergunta');

export const fetchEnquetesRespostas = () => apiService('/enquete/respostas');

export const postEnquetesVotar = async (body) => apiPost('/enquete/votar', body);

export const fetchPerguntasConselhoMunicipal = async () => apiService('/enquete/perguntasconselhomunicipal');

/* GENERICOS */

export const fetchCidades = () => apiService('/generico/cidades');

export const fetchNomeCidade = async (Valor) => apiPost('/generico/nomecidade', { Valor });

export const fetchVerificarStatusCidade = async (id) => apiService(`/${id}/generico/verificarativa`);

export const fetchLimparCookie = () => apiPostSemPost('/generico/limparcookie');

export const fetchEstadosTurismo = () => apiService('/generico/estados');

export const fetchCidadesTurismo = async (Valor) => apiPost('/generico/cidadesturista', { Valor });

export const fetchContatos = async () => apiService(`/${await getIdCidade()}/generico/informacoes`);

export const fetchBairros = async () => apiService(`/${await getIdCidade()}/generico/bairros`);

export const fetchAnos = async () => apiService(`/${await getIdCidade()}/generico/anos`);

export const fetchEventos = async () => apiService(`/${getIdCidadeEcrie()}/evento/listar`);

export const fetchEvento = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/evento/carregar`, { Valor });

export const fetchColeta = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/coletadelixo/carregar`, { Valor });

export const fetchColetas = async () => apiService(`/${getIdCidadeEcrie()}/coletadelixo/listar`);

export const fetchTelefones = async () => apiService(`/${getIdCidadeEcrie()}/telefoneuteis/listar`);

export const fetchTelefone = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/telefoneuteis/carregar`, { Valor });

export const fetchTransportesColetivo = async () => apiService(`/${getIdCidadeEcrie()}/transportecoletivo/listar`);

export const fetchTransporteColetivo = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/transportecoletivo/carregar`, { Valor });

export const fetchAgendas = async () => apiService(`/${getIdCidadeEcrie()}/agenda/listar`);

export const fetchAgenda = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/agenda/carregar`, { Valor });

export const fetchNocicias = async () => apiService(`/${getIdCidadeEcrie()}/noticia/listar`);

export const fetchNoticia = async (Valor) => apiPost(`/${await getIdCidadeEcrie()}/noticia/carregar`, { Valor });

export const fetchSecretarias = async (assunto) => apiService(`/${await getIdCidade()}/generico/secretarias${assunto ? `?assunto=${encodeURIComponent(assunto)}` : ''}`);

export const fetchSecretarias2 = async (assunto) => apiService(`/${await getIdCidade()}/generico/secretarias2${assunto ? `?assunto=${encodeURIComponent(assunto)}` : ''}`);

export const fetchSecretarias3 = async (assunto) => apiService(`/${await getIdCidade()}/generico/secretarias3${assunto ? `?assunto=${encodeURIComponent(assunto)}` : ''}`);

export const fetchSecretariasCartaServicos = async () => apiService(`/${await getIdCidade()}/generico/secretariascartadeservicos`);

export const fetchConfiguracoes = async () => apiService(`/${await getIdCidade()}/generico/cidadeconfiguracao`);

export const fetchOrientacoes = async (Valor) => apiPost('/generico/descricaoassunto', { Valor });

export const fetchCategorias = () => apiService('/generico/categorias');

export const fetchCategoriasPermitidas = async (Valor) => apiPost('/generico/categoriaspermitidas', { Valor });

export const fetchCategoriasSaude = () => apiService('/generico/categoriassaude');

export const fetchEscolaridades = () => apiService('/generico/escolaridades');

export const fetchFicouSabendo = () => apiService('/generico/ficousabendo');

export const fetchUrgenteJustificativas = () => apiService('/generico/justificativas');

/* OUVIDORIA */

export const postArquivo = (body) => upload(body);

export const postArquivos = (arquivos = []) => Promise.all(arquivos.map(postArquivo));

export const postOcorrencia = async ({ anexos, ...body }) => {
  if (anexos && anexos.length) {
    const arquivos = await postArquivos(anexos);
    if (arquivos.find(({ error }) => error)) {
      return arquivos;
    }

    return apiPost('/ouvidoria/cadastrar', {
      ...body,
      origem: (getTotem() !== 'true') ? '1' : '2',
      Foto: arquivos
        .map(({ remoteFileName }) => remoteFileName)
        .join(','),
    });
  }

  return apiPost('/ouvidoria/cadastrar', {
    ...body,
    origem: (getTotem() !== 'true') ? '1' : '2',
  });
};

export const postZeladoria = async ({ anexos, ...body }) => {
  if (anexos && anexos.length) {
    const arquivos = await postArquivos(anexos);
    if (arquivos.find(({ error }) => error)) {
      return arquivos;
    }

    return apiPost('/zeladoria/cadastrar', {
      ...body,
      origem: (getTotem() !== 'true') ? '1' : '2',
      Foto: arquivos
        .map(({ remoteFileName }) => remoteFileName)
        .join(','),
    });
  }

  return apiPost('/zeladoria/cadastrar', {
    ...body,
    origem: (getTotem() !== 'true') ? '1' : '2',
  });
};

export const postOpinar = async (body) => apiPost('/ouvidoria/opinar', body);

export const postInteragir = async ({ anexos, ...body }) => {
  if (anexos && anexos.length) {
    const arquivos = await postArquivos(anexos);
    if (arquivos.find(({ error }) => error)) {
      return arquivos;
    }

    return apiPost('/ouvidoria/interagir', {
      ...body,
      Foto: arquivos
        .map(({ remoteFileName }) => remoteFileName)
        .join(','),
    });
  }

  return apiPost('/ouvidoria/interagir', body);
};

export const postAtualizarVisualizadoManifestacao = (Valor) => apiPost('/ouvidoria/atualizarlidosolicitante', { Valor });

export const postAtualizarVisualizadoInteracaoManifestacao = (Valor) => apiPost('/ouvidoria/atualizarlidointeracaosolicitante', { Valor });

/* SIC */

export const fetchSicFrequentes = async () => apiService(`/${await getIdCidade()}/sic/perguntas`);

export const postRecurso = async (body) => apiPost('/sic/cadastrarrecurso', body);

export const postSic = async ({ anexos, ...body }) => {
  if (anexos && anexos.length) {
    const arquivos = await postArquivos(anexos);
    if (arquivos.find(({ error }) => error)) {
      return arquivos;
    }

    return apiPost('/sic/cadastrar', {
      ...body,
      OrigemCadastro: (getTotem() !== 'true') ? '1' : '2',
      Foto: arquivos
        .map(({ remoteFileName }) => remoteFileName)
        .join(','),
    });
  }

  return apiPost('/sic/cadastrar', {
    ...body,
    OrigemCadastro: (getTotem() !== 'true') ? '1' : '2',
  });
};

export const postAtualizarVisualizadoSic = (Valor) => apiPost('/sic/atualizarlidosolicitanteresposta', { Valor });

/* SOLICITANTE */

export const fetchVerificarAnonimo = async () => apiPost('/solicitante/anonimo');

export const fetchRecuperarAcesso = async (Valor) => apiPost(`/${await getIdCidade()}/solicitante/recuperaracesso`, { Valor });

export const fetchSolicitanteCampos = async () => apiService(`/${await getIdCidade()}/solicitante/campos`);

export const fetchSolicitanteCamposTotem = async () => apiService(`/${await getIdCidade()}/solicitante/camposTotem`);

export const fetchCarregarSolicitante = async () => apiService('/solicitante/carregar');

export const postCadastrarSolicitante = async (body) => apiPost(`/${await getIdCidade()}/solicitante/cadastrar`, body);

export const postAlterarSolicitante = async (body) => apiPost('/solicitante/alterar', body);

export const postCadastrarSolicitanteTotem = async (body) => apiPost(`/${await getIdCidade()}/solicitante/cadastrartotem`, body);

export const postAlterarSolicitanteTotem = async (body) => apiPost('/solicitante/alterartotem', body);

export const fetchSolicitanteOcorrencias = () => apiService('/solicitante/ouvidorias');

export const fetchSolicitanteOcorrenciasAnonimo = () => apiService('/solicitante/ouvidoriasanonima');

export const fetchOcorrenciaInteracoes = (Valor) => apiPost('/solicitante/ouvidoriasinteracoes', { Valor });

export const fetchSolicitanteSic = () => apiService('/solicitante/sics');

export const fetchSolicitanteSicAnonimo = () => apiService('/solicitante/sicsanonima');

export const fetchSolicitanteZeladoria = () => apiService('/solicitante/zeladorias');

export const fectchConselhoMunicipal = async () => apiService('/solicitante/conselhomunicipal');

/* GRAFICOS */

const parseGrafico = (data) => (
  data instanceof Array && data.length
    ? data.map(({ Label, Valor }) => ({ Label, Valor: +Valor }))
    : data
);

export const fetchGraficos = {
  ouvidoriaPrazos: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficoprazo`, body).then(parseGrafico),
  ouvidoriaSigiloso: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficosigiloso`, body).then(parseGrafico),
  ouvidoriaStatus: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficostatus`, body).then(parseGrafico),
  ouvidoriaTempoResposta: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficotemporesposta`, body),
  ouvidoriaPrimeiraResposta: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficoprimeiraresposta`, body).then(parseGrafico),
  sicPrazos: async (body) => apiPost(`/${await getIdCidade()}/sic/graficoprazo`, body).then(parseGrafico),
  sicSigiloso: async (body) => apiPost(`/${await getIdCidade()}/sic/graficosigiloso`, body).then(parseGrafico),
  sicStatus: async (body) => apiPost(`/${await getIdCidade()}/sic/graficostatus`, body).then(parseGrafico),
  pedido: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficopedido`, body).then(parseGrafico),
  pedidoAssunto: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficopedidoassunto`, body),
  pedidoSecretaria: async (body) => apiPost(`/${await getIdCidade()}/ouvidoria/graficopedidosecretaria`, body),
};

// Coronel Fabriciano - ID - 1177

/*
[Route("{idCidade}/ouvidoria/graficopedido")]
[Route("{idCidade}/ouvidoria/graficopedidoassunto")]
[Route("{idCidade}/ouvidoria/graficopedidosecretaria")]
*/

// Juiz de Fora - Escolaridade

export const fetchEscolasJuizDeFora = () => apiService('/generico/escolasjuizdefora');
